var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"inputRef",staticClass:"text-h5",attrs:{"filled":"","type":"text","hide-details":"","value":_vm.value,"label":_vm.label},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }